export default "__VITE_ASSET__CXFNcyPQ__"